import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { AUTH_ROUTES } from '../constants/auth-constants';
import { AuthSessionService } from '../services/auth-session';

export const loginRedirectGuard: CanActivateFn = (
  route,
  _state
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const sessionService = inject(AuthSessionService);

  const returnUrl = route.queryParams['returnUrl'] ?? AUTH_ROUTES.HOME;

  return sessionService.checkSession$().pipe(
    take(1),
    map((session) => {
      if (!session.isAuthenticated) {
        return true;
      }

      if (
        returnUrl &&
        returnUrl.startsWith('/') &&
        !returnUrl.includes('//') &&
        !returnUrl.includes(AUTH_ROUTES.LOGIN)
      ) {
        return router.createUrlTree([returnUrl]);
      }

      return router.createUrlTree([AUTH_ROUTES.HOME]);
    }),
    catchError(() => of(true))
  );
};
